export enum SelectedRating {
  None = 'NONE',
  Shocked = 'SHOCKED',
  Sad = 'SAD',
  Flat = 'FLAT',
  Smile = 'SMILE',
  Happy = 'HAPPY',
}
